export const columnsTracking = [
  { id: "idEmpresa", title: "Empresa", width: "25%", position: "EMPDESXX" },
  { id: "idProceso", title: "Proceso", width: "25%", position: "AREADESX" },
  { id: "idModificadoPor", title: "Modificado Por", width: "25%", position: "REGUSRNM" },
  { id: "idFechaModificacion", title: "Fecha de modificación", width: "15%", position: "REGFECMX" },
];

export const buttons = [
  { id: "idVerProceso", class: "bi bi-eye-fill", title: "Ver" },
  { id: "idEditarProceso", class: "bi bi-pencil-square", title: "Editar" },
];
